import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";

dayjs.extend(utc);
dayjs.extend(timezone);

const PARIS = "Europe/Paris";

function hasExplicitOffset(value) {
  if (typeof value !== "string") return false;
  return /Z$/i.test(value) || /[+-]\d{2}:?\d{2}$/.test(value);
}

/**
 * Instants coming from Mongo/OpenSearch without a timezone are UTC.
 * Display them in Europe/Paris (CEST in summer, CET in winter).
 * A dayjs object is converted as an instant (same clock, Paris zone).
 */
export function toParis(isoDate) {
  if (isoDate === null || isoDate === undefined || isoDate === "")
    return dayjs(NaN);
  if (dayjs.isDayjs(isoDate)) return isoDate.tz(PARIS);
  const value = String(isoDate);
  if (hasExplicitOffset(value)) return dayjs(value).tz(PARIS);
  return dayjs.utc(value).tz(PARIS);
}

/**
 * Civil times stored as naive wall-clock (agenda, réunions parlementaires).
 */
export function toWallClock(isoDate) {
  if (isoDate === null || isoDate === undefined || isoDate === "")
    return dayjs(NaN);
  if (dayjs.isDayjs(isoDate)) return isoDate;
  return dayjs(isoDate);
}

export function getDateShortFormat(isoDate) {
  return toParis(isoDate).format("DD/MM/YYYY");
}

export function getDateTimeShortFormat(isoDate) {
  return toParis(isoDate).format("DD/MM/YYYY HH:mm");
}

export function getDayTimeShortFormat(isoDate) {
  return toParis(isoDate).format("DD/MM/YYYY HH:mm");
}

export function getDateTimeHourFormat(isoDate) {
  return toParis(isoDate).format("D MMM YYYY HH:mm");
}

export function getDateLongFormat(isoDate) {
  return toParis(isoDate).format("DD MMMM YYYY");
}

export function getDateTimeLongFormat(isoDate) {
  return toParis(isoDate).format("dddd DD/MM/YYYY HH:mm");
}

export function getDayTimeFormat(isoDate) {
  return toParis(isoDate).format("lll");
}

export function getHourTimeFormat(isoDate) {
  return toParis(isoDate).format("HH:mm");
}

export function getMonthYearFormat(isoDate) {
  return toParis(isoDate).format("MMM YYYY");
}

export function getWallClockDateTimeLongFormat(isoDate) {
  return toWallClock(isoDate).format("dddd DD/MM/YYYY HH:mm");
}

export function getWallClockHourTimeFormat(isoDate) {
  return toWallClock(isoDate).format("HH:mm");
}

export function getWallClockDayTimeFormat(isoDate) {
  return toWallClock(isoDate).format("lll");
}
